module.exports = __webpack_public_path__ + "static/media/DIGITALIS-EXTIME-LOGOTYPE-2021-05.077b5b46.png";